<template>
    <div class="  con_content">
        <div class="container">
            <div class="container_top h_48">
                分类管理   
            </div>
            
            <div >

                <!-- table组件 -->
                <div class="my_table">
                    
                    <div class="my_search">
                        
                        <Row class="search_row overflow">  
                            <div  class="search_name">                             
                                <Button class="mR5" disabled   type="info"    @click='route="/layout/circle/classify/add";addFun();' > <Icon type="md-add" />添加</Button>                              
                                <!-- <Button class="mR5" type="info"    @click='route="/layout/circle/classify/add";addFun();' > <Icon type="md-add" />添加</Button>                               -->
                               
                            </div>
                            <div  class="search_name rgt iSwitch">
                                <i-switch style="transform:scale(1.2)"  size="large"  true-color="#13ce66" false-color="#ff4949"   v-model="type"  :true-value="Number(0)" :false-value="Number(1)"  @on-change="change_tasks">
                                    <span  slot="open">日常</span>
                                    <span  slot="close">新手</span>
                                </i-switch>
                            </div>
                        </Row>
                     
                    </div>
                
                
                </div>
                <!-- table组件 -->
                <div class="my_table  ">
                    <Header class="my_title txt_l">
                        <span class="my_titleL">
                        <Icon class="fw_900 " type="ios-list" size='30'/>     
                            数据列表 
                        </span>
                        
                        <div class="ct_rgt">
                            
                            <!-- <div class="sta_btn " type="primary"   @click="exportData">导出数据</div> -->
                            
                        </div>
                    </Header>
                    <Table     border :columns="columns1" :data="data1" ref='table'>
                    
                        
                        
                       
                        <!-- 按钮 -->
                        <template slot-scope="{ row, index }" slot="btn">
                            <!-- <Poptip trigger="hover" :title="row.surname" content="查看"> -->
                            
                            <Poptip trigger="hover"   content="编辑">
                                <Button class="padlr5" size="small"  @click='route="/layout/circle/task/editor";editorFun(row)'  type="success"      icon="md-open"></Button>
                            </Poptip>
                            <Poptip trigger="hover"  content="删除">
                                <Button class="padlr5"  size="small" @click='route="/layout/circle/task/del";delFun(row)'  type="error"      icon="md-close"></Button>
                            </Poptip>
                        
                        </template>
                        
                    </Table>
                
                    <!-- 任务编辑弹窗 -->
                    <Modal
                        v-model="modal1"
                        title="任务编辑"
                    
                        class-name="vertical-center-modal"
                    >
                        <div slot="footer">
                            <Button type='text' size='large' @click='cancel1'>取消</Button>
                            <Button type='primary' size='large' @click='ok1'>修改</Button>
                        </div>
                         
                        <Row :gutter="16">
                            <Col span="12">任务名称：</Col>
                            <Col span="12">获得孝心值：</Col>
                        </Row>                    
                        <Row :gutter="16">
                            <Col span="12"><Input v-model="editor.title"  placeholder="large size" /></Col>
                            <Col span="12"><Input v-model="editor.goldNum"  placeholder="large size" /></Col>
                        </Row> 
                        </br>                   
                        <Row :gutter="16">
                            <Col span="12">完成次数：</Col>
                            <Col span="12">任务排序：</Col>
                        </Row>                    
                        <Row :gutter="16">
                            <Col span="12"><Input v-model="editor.maxNum"  placeholder="large size" /></Col>
                            <Col span="12"><Input v-model="editor.sort"  placeholder="large size" /></Col>
                        </Row>  
                        </br>                  
                        <Row :gutter="16">
                            <Col span="12">任务描述：</Col>
                            <Col span="12">任务提示：</Col>
                        </Row>                    
                        <Row :gutter="16">
                            <Col span="12"><Input v-model="editor.desc" type="textarea" :rows="4"  placeholder="large size" /></Col>
                            <Col span="12"><Input v-model="editor.msg" type="textarea" :rows="4"  placeholder="large size" /></Col>
                        </Row> 
                        </br>
                        
                        
                        
                    </Modal>
                    

                    <!-- 任务添加弹窗 -->
                    <Modal
                        v-model="modal2"
                        title="任务添加"
                    
                        class-name="vertical-center-modal"
                    >
                        <div slot="footer">
                            <Button type='text' size='large' @click='cancel_add'>取消</Button>
                            <Button type='primary' size='large' @click='ok_add'>添加</Button>
                        </div>
                        <ul class="list_ul">
                        
                                
                            <!-- 任务描述 -->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 任务描述 :</div> 
                                <div class="list_con">
                                    <Input  v-model="add.desc"    type='text' class="ipt"  placeholder="请输入排序"    />
                                </div>                                            
                            </li>
                            <!-- 任务提示-->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 任务提示 :</div> 
                                <div class="list_con">
                                    <Input   v-model="add.msg"   type='text' class="ipt"  placeholder="请输入"    />
                                </div>                                            
                            </li>                                          
                            <!-- 任务标题-->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 任务标题 :</div> 
                                <div class="list_con">
                                    <Input   v-model="add.title"   type='text' class="ipt"  placeholder="请输入"    />
                                </div>                                            
                            </li>                                          
                            <!-- 任务类型 -->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 任务类型  :</div> 
                                <div class="list_con">
                                    <Input   v-model="add.type"   type='text' class="ipt"  placeholder="请输入1日常任务2新手任务 "    />
                                </div>                                            
                            </li>                                          
                            <!-- 孝心值 -->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 孝心值  :</div> 
                                <div class="list_con">
                                    <Input   v-model="add.goldNum"   type='text' class="ipt"  placeholder="请输入 "    />
                                </div>                                            
                            </li>                                          
                            <!-- 排序 -->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 排序  :</div> 
                                <div class="list_con">
                                    <Input   v-model="add.sort"   type='text' class="ipt"  placeholder="请输入 "    />
                                </div>                                            
                            </li>                                          
                            <!-- 是否隐藏 -->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 是否隐藏  :</div> 
                                <div class="list_con">
                                    <Input   v-model="add.isDisplay"   type='text' class="ipt"  placeholder="请输入1不隐藏2隐藏"    />
                                </div>                                            
                            </li>                                          
                            <!-- 完成次数 -->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 完成次数  :</div> 
                                <div class="list_con">
                                    <Input   v-model="add.maxNum"   type='text' class="ipt"  placeholder="请输入 "    />
                                </div>                                            
                            </li>                                          
                            
                        
                        
                        </ul>
                    </Modal>
                    <!-- 确认删除框 -->
                    <Modal
                        v-model="delM"
                        title="提示"
                        @on-ok="delOk"
                        @on-cancel="cancel"
                        class-name="vertical-center-modal"
                    >
                        <p>确定删除吗?</p>
                        
                    </Modal>
                </div>

            </div>

       </div>
       
  </div>

</template>

<script>
    import { mapState,mapMutations,mapGetters } from 'vuex';
    import { format } from 'path';
    

    export default {
        name:'classify',
        data () {
            return {
            
                route: null,
                token:'',
               

                columns1:[],
                  
                data1:[],
                

                checkGuid2:'',
           
              
  
                modal1: false, // 编辑分类
                modal2: false,   //添加分类
                delM: false,

                // 添加 
                add: {
                    route: '/layout/circle/classify/editor',
                    desc: null,
                    msg: null,
                    title: null,
                    type: null,
                    goldNum: null,
                    sort: null,
                    isDisplay: null,
                    maxNum: null
                },
                // 任务类型
                type: 0,
                // 添加 
                editor: {
                    desc: null,
                    msg: null,
                    title: null,
                    type: null,
                    goldNum: null,
                    sort: null,
                    isDisplay: null,
                    maxNum: null
                },
            }
        },
     
        watch:{
           
          
        },
       
        computed: {
         
         
            
        },
        
        methods: {
           load(){
              let that = this;
              
              that.$myAjax.get(
                    'admin/service/admin/daily/tasks/get'
              ).then(res => {
                  
                   that.columns1 = [
                       {title:'任务名称',key:'title',align:'center'},
                       {title:'修改时间',key:'createTime',align:'center'},
                       {title:'获得孝心值',key:'goldNum',align:'center'},
                       {title:'是否显示',key:'isDisplay',align:'center',
                            render: (h, params) => {
                           
                              return h('i-switch', {
                                      
                                      props: {
                                          size: "large",
                                          value: params.row.isDisplay == "1"
                                      },
                                      on: {
                                          'on-change': (value) => {
                                              let val;
                                              if(value){
                                                val = 1
                                              }else{
                                                val = 2
                                              }

                                              that.$myAjax.post(
                                                    'admin/service/admin/daily/tasks/update?route=/layout/circle/task/editor',
                                                    {
                                                        "guid": params.row.guid,
                                                        "isDisplay": val
                                                    },
                                                  
                                              ).then(res => {
                                                
                                          
                                              }).catch(err=>{
                                                  console.log(err)
                                              })


                                          }
                                      }
                                  },
                                  [h('span', {
                                          slot: "open",
                                          domProps: {
                                              innerHTML: '开启'
                                          }
                                      }),
                                      h('span', {
                                          slot: "close",
                                          domProps: {
                                              innerHTML: '关闭'
                                          }
                                      }),
                                  ]
                              )
                            }

                      },
                      {title:'操作',slot:'btn',align:'center',fixed: 'right'}
                   ];

                   if( this.type+1 == 1 ){
                        
                        that.data1 = res.data.data.dailyTasks;
                   }else{
                        that.data1 = res.data.data.noviceTasks; 
                   }
                   
                   
                });
           },
            change_tasks(){
                this.load();
            },
          
            
           // 用户组名编辑
            editorFun(res){
                let that = this;
                

                that.$canBtn( that.route).then( function(res_c){
                    that.modal1 = true;
    
                    that.guid = res.guid;
                    
                    that.editor.desc=res.desc,
                    that.editor.msg=res.msg,
                    that.editor.title=res.title,
                    that.editor.type=res.type,
                    that.editor.goldNum=res.goldNum,
                    that.editor.sort=res.sort,
                    that.editor.isDisplay=res.isDisplay,
                    that.editor.maxNum=res.maxNum
                })
            },
           

            //    编辑弹窗
            ok1() {
                var that = this;
                that.$myAjax.post(
                    'admin/service/admin/daily/tasks/update?route=/layout/circle/task/editor',
                    {
                        guid: that.guid,
                        desc: that.editor.desc,
                        msg: that.editor.msg,
                        title: that.editor.title,
                        type: that.editor.type,
                        goldNum: that.editor.goldNum,
                        sort: that.editor.sort,
                        isDisplay: that.editor.isDisplay,
                        maxNum: that.editor.maxNum
                    },
                  
                ).then(res => {
                   
                    if(res.data.code == 1){
                        that.load();
                        that.cancel1();
                    }
                }).catch(err=>{
                    console.log(err)
                })

                
                
            },
            cancel1() {
                this.modal1 = false;
               
               
            },
           
            // 删除用户组
            delFun(res){
                let that = this;

                that.guid = res.guid;
                that.$canBtn( that.route).then( function(res_c){
                    that.guid = res.guid;
                    that.delM = true;
                })
            },
            delOk(){
                let that = this;
                that.$myAjax.delete(
                    'admin/service/admin/daily/tasks/delete?guid='+that.guid+'&route='+that.route,
                    {
                    },
                   
                ).then(res => {
                    
  
                    that.load();
                })
                
            },
            
            
            // 顶部添加
            
            addFun(){
                let that = this;
                

                that.$canBtn( that.add.route).then( function(res_c){
                    that.modal2 = true;

                })
            },
            ok_add(){
                let that = this;
               
                that.$myAjax.post(
                    'admin/service/admin/daily/tasks/add?route='+that.route,
                    {
                        
                        desc: that.add.desc,
                        msg: that.add.msg,
                        title: that.add.title,
                        type: JSON.parse(that.add.type),
                        goldNum: JSON.parse(that.add.goldNum),
                        sort: JSON.parse(that.add.sort),
                        isDisplay: JSON.parse(that.add.isDisplay),
                        maxNum: JSON.parse(that.add.maxNum)  
                  
                    },
                    
                    
                ).then(res => {
                  
                    if(res.data.code != 0){
                        that.load();
                        that.cancel_add();

                        that.add.desc = null,
                        that.add.msg = null,
                        that.add.title = null,
                        that.add.type = null,
                        that.add.goldNum = null,
                        that.add.sort = null,
                        that.add.isDisplay = null,
                        that.add.maxNum = null  
                    }
                    
                })
                    
                
               
            },
            cancel_add(){
            
                this.modal2 = false;
            },

            cancel(){},

            
         
        },
        mounted: function(){
           var that = this;
           that.vCropper = that.$store.state.vCropper;
           
           that.token = that.$store.state.token;
           
           that.load();
         
        }
    }
</script>
<style scoped>
     /* public 内容用  /就行 */
     @import "/css/modal.css";

     /* 表格下方无翻页按钮时 */
    .ivu-table-wrapper{
        margin-bottom: 50px;
    }

    .iSwitch{
        padding-right: 18px;
    }
    
</style>

